module.exports = __webpack_public_path__ + "static/media/33_A.0abb6c7d.png";